import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserJobMatchingGame from 'src/games/JobMatchingGame/Main';

interface JobMatchingGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class JobMatchingGame extends React.Component<JobMatchingGameProps> {
    constructor(props: JobMatchingGameProps) {
        super(props);
        bindAllOfThis(this, JobMatchingGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserJobMatchingGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default JobMatchingGame;



// WEBPACK FOOTER //
// ./src/pages/game/PlatformerGame.tsx